import { render, staticRenderFns } from "./NewProductSlider.vue?vue&type=template&id=118bb570&scoped=true"
import script from "./NewProductSlider.vue?vue&type=script&lang=js"
export * from "./NewProductSlider.vue?vue&type=script&lang=js"
import style0 from "./NewProductSlider.vue?vue&type=style&index=0&id=118bb570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118bb570",
  null
  
)

export default component.exports